<template>
  <a-modal
    title="拉取广告主"
    centered
    :width="640"
    :mask-closable="false"
    :visible="showForm"
    :confirmLoading="loading"
    @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-spin :spinning="loading">
        <a-form-model-item label="授权账号" prop="account_id">
          <a-select placeholder="请选择" show-search option-filter-prop="children" v-model="model.account_id">
            <template v-if="accounts.length > 0">
              <a-select-option :value="account.id" v-for="account in accounts" :key="account.id">
                {{ account.name }}
              </a-select-option>
            </template>
          </a-select>
        </a-form-model-item>
      </a-spin>
    </a-form-model>

    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'Pull';
</style>

<script>
import Pull from './Pull'
export default Pull
</script>